import React from "react";
import { PLANNING_DETAILS, detailTables, reviewIssues } from "./planningDetails";

export function PlanningDetails({ templateId, values, onChange }) {
  const fields = PLANNING_DETAILS[templateId]?.fields || [];
  const control = (f, value, change, id) => {
    const props = {
      id, value: value || "", onChange: (e) => change(e.target.value),
      className: "mt-1 w-full rounded-md border border-stone-300 bg-white p-2 text-sm text-stone-900",
    };
    if (f.type === "select") return <select {...props}><option value="">Choose…</option>{f.options.map((o) => <option key={o}>{o}</option>)}</select>;
    if (f.type === "date") return <input {...props} type="date" />;
    return <textarea {...props} rows={2} />;
  };
  return <details className="mt-5 rounded-lg border border-stone-200 bg-white p-4">
    <summary className="cursor-pointer font-semibold text-emerald-900">Planning detail &amp; review evidence (expand as needed)</summary>
    <p className="mt-3 text-sm text-stone-600">These optional records support the next decision. Save with the worksheet. A named reviewer or recorded outcome is your report of a review, not verified sign-off or safety/regulatory approval. Record document locations; file uploads are not provided here.</p>
    <div className="mt-4 space-y-4">
      {fields.map((f) => <div key={f.id}>
        <label htmlFor={`${templateId}-${f.id}`} className="text-sm font-medium">{f.label}</label>
        {control(f, values[f.id], (value) => onChange({ ...values, [f.id]: value }), `${templateId}-${f.id}`)}
      </div>)}
      {detailTables(templateId).map((table) => {
        const rows = Array.isArray(values[table.id]) ? values[table.id] : [];
        return <section key={table.id} className="border-t border-stone-200 pt-4">
          <h4 className="font-semibold">{table.title}</h4>
          {rows.map((row, i) => <fieldset key={i} className="my-3 rounded-lg border border-stone-200 p-3">
            <legend className="px-1 text-sm font-semibold">Record {i + 1}</legend>
            <div className="grid gap-3 sm:grid-cols-2">{table.columns.map((f) => <div key={f.id}>
              <label className="text-sm" htmlFor={`${templateId}-${table.id}-${i}-${f.id}`}>{f.label}</label>
              {control(f, row[f.id], (value) => onChange({ ...values, [table.id]: rows.map((r, n) => n === i ? { ...r, [f.id]: value } : r) }), `${templateId}-${table.id}-${i}-${f.id}`)}
            </div>)}</div>
            <button type="button" className="mt-3 text-sm text-red-800 underline" onClick={() => {
              if (window.confirm("Remove this record? The change is saved when you save the worksheet.")) onChange({ ...values, [table.id]: rows.filter((_, n) => n !== i) });
            }}>Remove record {i + 1}</button>
          </fieldset>)}
          <button type="button" className="mt-3 rounded-md border border-emerald-800 px-3 py-2 text-sm text-emerald-900" onClick={() => onChange({ ...values, [table.id]: [...rows, {}] })}>Add {table.title.toLowerCase()} record</button>
        </section>;
      })}
      {reviewIssues(values).map((issue) => <p role="alert" className="text-sm text-amber-900" key={issue}>{issue}</p>)}
    </div>
  </details>;
}